import AdUnit from '../../core/AdUnit';

import {
  AD_BEFORE_COMPLETE_DELAY,
  AdUnitStatus,
  AdvIDPrefix,
  event,
  Platform,
  PlayerType,
  YANDEX_SDK_URL,
  YandexRTBType
} from '../../utils/const'
import { getRandomString } from '../../utils/utils';
import LibLoader from "../../utils/LibLoader";

const IMPRESSION_TIMEOUT = 1000;

const detectYandexVideo = async (slot) => {
  return new Promise((resolve, reject) => {
    const findVideoTag = (slot) => {
      const list = Array.from(slot.querySelectorAll('*'))
      for (let elem of list) {
        const vid = elem.querySelector('video');
        if (vid || elem.tagName === 'video') {
          return true
        }

        if (elem.shadowRoot) {
          return findVideoTag(elem.shadowRoot)
        }
      }
      return false
    }

    let videoDetected = false
    let interval = setInterval(() => {
      videoDetected = findVideoTag(slot)
      if (videoDetected) {
        clearInterval(interval)
        resolve(videoDetected)
      }
    }, 100)

    setTimeout(() => {
      clearInterval(interval)
      resolve(videoDetected)
    }, 1000)
  })
}

class YandexRTB extends AdUnit {
  constructor(cfg) {
    super(cfg);

    this.originalWidth = this.slot.clientWidth;
    this._inView = false;
    // this.iframe = null;
    this.window = window;
    this.scope = cfg.scope;

    this.initTimer = null;

    this.steps = []; // debug

    this.emitter.on(event.Player.ViewabilityStatusChanged, this._onViewabilityStatusChanged);

    this.steps.push(1)
    this.prepare();
  }

  prepare() {
    if (!this.scope) {
      this.timers.initTimer = setTimeout(() => {
        this.logger.log('[YandexRTB] init AdUnit timeout');
        this.localEmitter.emit(event.Ad.AdError, { code: 11 });
      }, 5000);

      this.slot.style.maxHeight = 'var(--vads-yandex-max-height)';

      this.innerSlot = document.createElement('div');
      this.innerSlot.style.cssText = 'width: var(--vads-player-width);'; // height: var(--vads-player-height);
      // this.innerSlot.id = getRandomString();
      this.slot.appendChild(this.innerSlot);

      if (!(window.Ya && window.Ya.Context)) {
        return LibLoader.load(YANDEX_SDK_URL,
          () => this.init(),
          () => {
            this.logger.log('[YandexRTB] error during load library');
            this.localEmitter.emit(event.Ad.AdError, { code: 9 });
          }
        );
      } else {
        this.init();
      }
    } else {
      this.slot.remove(); // remove old slot

      this.inFrame = true;

      // this.scope = new YandexRTBScope({ container: this.config.playerNode });
      this.slot = this.scope.getIFrame();
      this.slot.style.height = '100%';

      if (!this.scope.ready) {
        this.scope.subscribe(() => { this.window = this.slot.contentWindow; this.steps.push(23); this.init() });
      } else {
        this.window = this.slot.contentWindow; // TODO: move to init?
        try {
          this.init();
        } catch(e) {
          // console.log('error here', e);
          this.status = AdUnitStatus.ERROR;
          // return this.emitter.emit(event.Player.RefreshYandexRTBScope);
          return this.emitter.emit(event.Player.RefreshIFrameScope, { scopeName: this.scope.prefix });
        }
      }
    }
  }

  init = () => {
    this.logger.log(`[YandexRTB - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _init() called`, this.config);

    const { template } = this.config;
    this.parsedTemplate = JSON.parse(template);
    const { type } = this.parsedTemplate;

    this.advID = (type === YandexRTBType.video ? AdvIDPrefix.YANDEX : AdvIDPrefix.YANDEX_BANNER) + getRandomString();

    // this.slot.id = getRandomString();
    this.slot.setAttribute('platform', 'yandex');

    if (this.window.frameElement) {
      this.scope.addSlot(this.advID);
    } else {
      this.steps.push(10)
      this.innerSlot.id = this.advID;
    }

    this.window.yaContextCb = this.window.yaContextCb || [];
    // window.yaContextCb = window.yaContextCb || [];

    if (this.timers.initTimer) {
      clearTimeout(this.timers.initTimer);
      this.timers.initTimer = null;
    }
    this.steps.push(12)
    this.status = AdUnitStatus.LOADED;
  }

  _onViewabilityStatusChanged = ({ status }) => {
    this._inView = status;

    if (this._inView && this.status === AdUnitStatus.PLAYING && !this.timers.bannerShow) {
      this.timers.bannerShow = setTimeout(() => {
        this.localEmitter.emit(event.Ad.AdVideoComplete);
      }, this.config.timeouts.yab || 15000);
    }
  }

  _updateTopOffset = () => {
    // const offset = (this.slot.clientHeight - this.innerSlot.clientHeight) / 2;
    // this.slot.style.paddingTop = `${offset}px`; // !!!
  }

  _onYandexRTBImpressionTimeout = () => {
    this._updateTopOffset();
    // const offset = (this.slot.clientHeight - this.innerSlot.clientHeight) / 2;
    // console.log('offset', offset);
    // this.slot.style.paddingTop = `${offset}px`;

    const { type } = this.config.playerConfig;
    const impressionCondition = (type === PlayerType.INPAGE || type === PlayerType.FLOATING) ? this._inView : true;

    if (impressionCondition) {
      this.localEmitter.emit(event.Ad.AdImpression);
    } else {
      this.timers.yandexRTBImpression = setTimeout(() => this._onYandexRTBImpressionTimeout(), IMPRESSION_TIMEOUT);
    }
  }

  // checkScopeAlive = () => this.slot.contentDocument;

  start = () => {
    this.logger.log(`[YandexRTB - ${this.config.params.tid}] start() called`);

    this._startTimestamp = Date.now();
    // resetActiveSlots(this.config.playerNode, true);
    // setTimeout(() => { this.slot.classList.add('active') }, 0);

    if (this.config.playerConfig.type === PlayerType.SLIDER) {
      this.timers.startAd = setTimeout(() => {
        this.logger.log(`[YandexRTB - ${this.config.playerConfig.zone} / ${this.config.params.tid}] startAd timeout`);
        this.localEmitter.emit(event.Ad.AdError, { code: 2 });
      }, this.config.timeouts.yartbstart || 5000);
    }

    this.timers.durationAd = setTimeout(() => {
      this.logger.log(`[YandexRTB - ${this.config.playerConfig.zone} / ${this.config.params.tid}] durationAd timeout`);
      this.localEmitter.emit(event.Ad.AdError, { code: 3 });
    }, 45000);

    try {
      this.emitter.emit(event.Player.YandexAdStarted, { isBanner: false, });
      this.originalWidth = this.slot.clientWidth;

      // const target = this.yaRTBScope ? this.yaRTBScope.getIFrame() : this.slot;
      // this.slot.style.zIndex = '15';
      this.window.yaContextCb.push(() => {
        if (this.config.params.platform === Platform.YANDEX) {
          const { siteid, blockid } = this.parsedTemplate;

          this.window.Ya.Context.AdvManager.render({
            blockId: blockid,
            statId: siteid,
            // renderTo: this.window.frameElement ? this.advID : this.innerSlot.id, // this.innerSlot.id, // this.slot.id,
            renderTo: this.advID,
            async: true,
            videoCallbacks: {
              onAdStart: () => {
                if (this.status === AdUnitStatus.FINISHED || this.status === AdUnitStatus.ERROR) return;
                this.logger.log('[YandexRTB] onAdStart');
                clearTimeout(this.timers.bannerShow);

                this.localEmitter.emit(event.Ad.AdImpression);
                // this.slot.style.zIndex = '';
                // setTimeout(() => { this.slot.style.zIndex = ''; }, 500);
              },
              onAdEnd: (...e) => {
                if (this.status === AdUnitStatus.FINISHED || this.status === AdUnitStatus.ERROR) return;
                this.logger.log('[YandexRTB] onAdEnd', e);

                clearTimeout(this.timers.durationAd);
                setTimeout(() => {
                  // this.emitter.off(event.Player.ViewabilityStatusChanged, this._onViewabilityStatusChanged);
                  // this.debug_removeAd.remove();
                  // if (this.inFrame) this.slot.contentDocument.getElementById('ya_rtb').innerHTML = '';
                  this.localEmitter.emit(event.Ad.AdVideoComplete);
                }, AD_BEFORE_COMPLETE_DELAY);
              },
            },
            onRender: async () => {
              if (this.status === AdUnitStatus.FINISHED || this.status === AdUnitStatus.ERROR) return;

              this._updateTopOffset();

              // this.emitter.emit(event.Player.ToggleControls, false);

              // const offset = (this.slot.clientHeight - this.innerSlot.clientHeight) / 2;
              // console.log('offset', offset);
              // this.slot.style.paddingTop = `${offset}px`;

              this.isVideo = await detectYandexVideo(this.inFrame ? this.slot.contentDocument.body.querySelector(`#${this.advID}`) : this.slot);

              this.originalWidth = this.slot.clientWidth;

              // this.emitter.emit(event.Player.ExpandRequest);

              // if (type === YandexRTBType.banner) {
              //   clearTimeout(this.timers.startAd);

              //   this.slot.style.backgroundColor = '#232323';
              //   this.localEmitter.emit(event.Ad.AdImpression);

              //   this.timers.bannerShow = setTimeout(() => {
              //     this.localEmitter.emit(event.Ad.AdVideoComplete);
              //   }, BANNER_TIMEOUT);
              // }

              // const condition = (type === PlayerType.INPAGE || type === PlayerType.FLOATING) ? this._inView : true; // TODO: need refactioring
              // if (condition) {
              //   this.timers.bannerShow = setTimeout(() => {
              //     this.localEmitter.emit(event.Ad.AdVideoComplete);
              //   }, this.config.timeouts.yab || 15000);
              // }

              // this.timers.yandexRTBImpression = setTimeout(() => this._onYandexRTBImpressionTimeout(), IMPRESSION_TIMEOUT);

              if (!this.isVideo) {
                this.timers.yandexRTBImpression = setTimeout(() => this.localEmitter.emit(event.Ad.AdImpression), 1000);
                this.timers.bannerShow = setTimeout(() => {
                  this.localEmitter.emit(event.Ad.AdVideoComplete);
                }, this.config.timeouts.yab || 15000);
              } else {
                clearTimeout(this.timers.startAd);
                this.timers.startAd = null;
              }

              this.localEmitter.emit(event.Ad.AdVideoStart);
            },
            onError: (e) => {
              if (this.status === AdUnitStatus.FINISHED || this.status === AdUnitStatus.ERROR) return;

              clearTimeout(this.timers.durationAd);

              // this.debug_removeAd.remove();

              // this.emitter.off(event.Player.ViewabilityStatusChanged, this._onViewabilityStatusChanged);
              this.logger.log(`[YandexRTB - ${this.config.params.tid}] onError`, e, this);
              this.localEmitter.emit(event.Ad.AdError, { code: 5 });
            },
          }, () => {
            clearTimeout(this.timers.durationAd);

            // this.debug_removeAd.remove();

            // this.emitter.off(event.Player.ViewabilityStatusChanged, this._onViewabilityStatusChanged);
            this.logger.log(`[YandexRTB - ${this.config.params.tid}] noads error`);
            this.localEmitter.emit(event.Ad.AdError, { code: 1 });
          });
        } else if (this.config.params.platform === Platform.ADFOX) {
          const { ownerId, params } = this.parsedTemplate;
          this.window.Ya.adfoxCode.create({
            ownerId,
            containerId: this.iframe ? 'ya_rtb' : this.innerSlot.id,
            params: {
              ...params,
              // pp: 'i',
              // ps: 'hfsw',
              // p2: 'p',
            },
            onClose: () => {
              this.logger.log('[AdFox] onClose');
            },
            onError: (error) => {
              this.logger.log('[AdFox] onError', error);
              this.localEmitter.emit(event.Ad.AdError, { code: 5 });
            },
            onLoad: (data) => {
              this.logger.log('[AdFox] onLoad', data);
            },
            onRender: async () => {
              this.logger.log('[AdFox] onRender');

              const isVideo = await detectYandexVideo(this.slot);

              this.localEmitter.emit(event.Ad.AdVideoStart);
              this.timers.yandexRTBImpression = setTimeout(() => this.localEmitter.emit(event.Ad.AdImpression), 1000);
            },
            onStub: () => {
              this.logger.log('[AdFox] onStub');
              this.localEmitter.emit(event.Ad.AdError, { code: 1 });
            },
          });
        }
      });
    } catch (e) {
      clearTimeout(this.timers.durationAd);
      this.logger.log('YandexRTB err: ', e);

      // if (this.inFrame) this.emitter.emit(event.Player.RefreshYandexRTBScope);
      console.log('handle 2');
      if (this.inFrame) this.emitter.emit(event.Player.RefreshIFrameScope, { scopeName: this.scope.prefix });
    }
  }
  resize = (width, height) => {
    // this.slot.style.overflow = "hidden";

    const scale = width / this.originalWidth;
    this.innerSlot.style.cssText = `position: absolute; left: 50%; overflow: visible; transform-origin: left top; transform: scale(${scale}) translateX(-50%);`; // this.slot
  }
}

export default YandexRTB;
